export default __webpack_public_path__ + "static/media/391.c6dfe870.gif";